/**
 * 地址验证配置
 */

/**
 * 组件确认级别枚举
 */
export enum ConfirmationLevel {
	/** 已确认 */
	CONFIRMED = "CONFIRMED",
	/** 未确认但可信 */
	UNCONFIRMED_BUT_PLAUSIBLE = "UNCONFIRMED_BUT_PLAUSIBLE",
	/** 未确认且可疑 */
	UNCONFIRMED_AND_SUSPICIOUS = "UNCONFIRMED_AND_SUSPICIOUS",
}

/**
 * 组件类型枚举
 */
export enum ComponentType {
	/** 街道门牌号 */
	STREET_NUMBER = "street_number",
	/** 街道名称 */
	ROUTE = "route",
	/** 城市 */
	LOCALITY = "locality",
	/** 邮编 */
	POSTAL_CODE = "postal_code",
	/** 省/州 */
	ADMINISTRATIVE_AREA_LEVEL_1 = "administrative_area_level_1",
	/** 国家 */
	COUNTRY = "country",
	/** 邮政城镇 */
	POSTAL_TOWN = "postal_town",
}

/**
 * 地址验证服务配置
 */
export const ADDRESS_VALIDATION_CONFIG = {
	/** Google Address Validation API 基础URL */
	API_BASE_URL: "https://addressvalidation.googleapis.com/v1:validateAddress",
	/** 请求超时时间（毫秒） */
	REQUEST_TIMEOUT: 10000,
	/** 最大重试次数 */
	MAX_RETRIES: 3,
} as const
